import { render } from "./HugValue.vue?vue&type=template&id=9d62415c"
import script from "./HugValue.vue?vue&type=script&lang=js"
export * from "./HugValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__